import { ISarTableDataSubRoot } from '@discngine/moosa-models';

export const selectSarPinnedSubstances = (state: ISarTableDataSubRoot) =>
  state.sarTableData.pinnedSubstances;

export const selectSarTableId = (state: ISarTableDataSubRoot) =>
  state.sarTableData.tableId;
